import useStyle from './reintialiserContent.style';
import { renewPassword } from 'REST/password/renew';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { useParams } from 'react-router-dom';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import React, { useEffect, useState } from 'react';
import pages from 'routes/pages';
import { unloggedStrapiAxios } from 'REST/strapiAxios';
import { getAxiosMessageError } from 'helpers/errors/axios.error';
import { LabelInput } from 'components/atoms/Inputs/LabelInput';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import toast from 'react-hot-toast';

const reinitPass = async (
  id: string,
  password: string,
  passwordConfirmation: string,
  dispatch: Dispatch,
  e = null
) => {
  e && e.preventDefault();
  try {
    const res = await renewPassword({
      code: id,
      password,
      passwordConfirmation
    });
    toast.success(res);
    setTimeout(() => window.location.assign(pages.HOME_PAGE.path), 2000);
  } catch (err) {
    console.warn(err);
  }
};

const errPolicy = val =>
  val.password.length < 6
    ? 'Le mot de passe doit comporter au moins 6 carractère '
    : val.password !== val.passwordConfirmation
    ? 'Les mots de passe de conrespondent pas'
    : false;

interface StateRenew {
  password: string;
  passwordConfirmation: string;
  error: string | boolean;
}

export const ReinitialiserContent = ({ match }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const [isValidToken, setIsValidToken] = useState<boolean>(false);
  const [renew, setRenew] = useState<StateRenew>({
    password: '',
    passwordConfirmation: '',
    error: true
  });

  useEffect(() => {
    unloggedStrapiAxios
      .post('/users-permissions/users/isRefreshTokenValid', {
        refreshToken: id
      })
      .then(res => setIsValidToken(res.data))
      .catch(err => toast.error(getAxiosMessageError(err)));
  }, [id]);

  const handleChange = async e => {
    const newState = {
      ...renew,
      [e.target.name]: e.target.value
    };

    await setRenew({
      ...newState,
      error: errPolicy(newState)
    });
  };

  if (!isValidToken)
    return (
      <ErrorContainer
        text={
          "Le lien n'est plus actif, veuillez refaire une demande de renouvellement de mot de passe"
        }
      />
    );

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Changer votre mot de passe</h1>
      <p>
        Taper 2 fois votre nouveau mot de passe. Il doit contenir au moins 6
        caractères.
      </p>
      <div className={classes.formContainer}>
        <FeatureContainer>
          <div className={classes.form}>
            <LabelInput
              label="Votre mot de passe"
              required={true}
              name="password"
              placeHolder="ex : mdp1234$..."
              onChange={handleChange}
              value={renew.password}
            />
            <LabelInput
              label="Confirmez votre mot de passe"
              required={true}
              name="passwordConfirmation"
              placeHolder="ex : mdp1234$..."
              onChange={handleChange}
              value={renew.passwordConfirmation}
            />
            {renew.error && <p className={classes.help}>{renew.error}</p>}
            <div className={classes.buttons}>
              <ButtonWithText
                content="Envoyer"
                onClick={e =>
                  reinitPass(
                    match?.params?.id,
                    renew?.password,
                    renew?.passwordConfirmation,
                    dispatch,
                    e
                  )
                }
                disabled={!!renew.error}
              />
            </div>
          </div>
        </FeatureContainer>
      </div>
    </div>
  );
};
